<template >
  <div class="mainbody">
    <div class="mainbody">
      <div class="top">
        <h3 class="title">待审核</h3>
        <div class="btn-group-custom">
          <el-button type="text" @click="$pass(1)">通过</el-button>
          <el-button type="text" @click="$pass(2)">拒绝</el-button>
          <el-button type="text" @click="$del()">删除</el-button>
          <!-- <el-button type="text">删除</el-button> -->
          <!-- <el-button type="text" @click="download()">导出</el-button> -->
        </div>
      </div>
      <div class="aLine"></div>

      <div class="box">
        <!-- <div class="selectTitle" v-if="selectSize > 0">
          <span class="el-icon-info" style="color: #2383e0"></span>
          <span style="margin-left: 10px">已选择</span>
          <span class="selectTitleNum">{{ selectSize }}</span>
          <span>条信息</span>
          <el-button type="text" class="selectTitleClear" @click="cleanTable()"
            >清空</el-button
          >
        </div> -->
        <div class="tableInfo survey-list">
          <el-table
            :data="audit_list"
            v-loading="loading"
            style="width: 100%"
            :height="height"
            @selection-change="handleSelectionChange"
          >
            <el-table-column fixed type="selection" width="50px" align="center">
            </el-table-column>
            <el-table-column fixed label="详情" width="70px" align="center">
              <template slot-scope="scope">
                <el-button
                  class="operateText"
                  type="text"
                  @click="surveyInfo(scope.row)"
                  ><i class="el-icon-view"></i
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="answer_id"
              label="编号"
              width="70px"
              align="center"
            >
            </el-table-column>
            <el-table-column fixed prop="name" width="120" label="校友名称">
            </el-table-column>
            <el-table-column prop="student_no" width="120" label="校友学号">
            </el-table-column>
            <el-table-column prop="updateTime" min-width="160" label="提交时间">
            </el-table-column>
            <el-table-column
              v-for="item in question_list"
              :key="item.id"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
            >
              <template slot-scope="scope">
                <p
                  v-text="getValue(scope.row, item.id)"
                  v-if="item.type == 'text'||item.type == 'textarea'"
                ></p>
                <el-image
                  style="width: 100%; height: 60px"
                  :src="getValue(scope.row, item.id)"
                  :preview-src-list="[getValue(scope.row, item.id)]"
                  fit="contain"
                  v-if="[getValue(scope.row, item.id, true)] == 'image'"
                ></el-image>
                <p
                  style="text-align: center"
                  v-if="[getValue(scope.row, item.id, true)] == 'upload'"
                >
                  <a target="_blank" :href="getValue(scope.row, item.id)"
                    >附件下载</a
                  >
                </p>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :key="elementui_page_key"
            class="elPagination"
            background
            layout="prev, pager, next"
            :page-size="pageMaxSize"
            :page-count="pageCount"
            :current-page="currentPage"
            @current-change="currentChange"
          ></el-pagination>
          <surveyExportAnswerList
            ref="_surveyExportAnswerList"
          ></surveyExportAnswerList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import SurveyExportAnswerList from "@/components/survey/surveyExportAnswerList";

export default {
  components: {
    SurveyExportAnswerList
  },
  props: {
    survey_info: {
      type: Object
    }
  },

  data() {
    return {
      survey_id: null,
      audit_list: null,
      question_list: [], //问卷字段名
      loading: true,
      height: "650",
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      // pageMaxSize: 2,
      currentPage: 1,
      selection: [], // 已勾选的问卷id
      delSelection: [], // 已勾选的问卷answer_id
      // export_selection: [] // 已勾选导出的问卷id
      selectSize: 11
    };
  },
  methods: {
    initData() {},
    // 获取审核列表
    getAuditList() {
      this.loading = true;
      this.$api
        .surveyAudit({
          token: localStorage.getItem("token"),
          survey_id: localStorage.getItem("survey_id") || "",
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getAuditList();
          }
          this.pageCount = data.Data.pageCount;
          this.audit_list = data.Data.model;
          if (this.audit_list.length > 0) {
            this.audit_list.forEach((item) => {
              item.updateTime = Utils.dateFormat(item.update_time * 1000);
            });
          }
          if (this.question_list.length == 0) {
            this.getQuetionList();
          }
          this.loading = false;
        })
        .catch(({ error }) => {
          this.loading = false;
        });
    },
    //获取问卷字段名
    getQuetionList() {
      let arr = [];
      let value = "";
      let width = 0;
      this.survey_info.fields.forEach((item, index) => {
        if (item.type != "description") {
          value = item.title;
          if (index < this.survey_info.fields.length - 1) {
            if (item.title) {
              width =
                value.length * 10 + 12 < 130 ? 130 : value.length * 10 + 12;
              this.question_list.push({
                id: item.id,
                label: value,
                width: width,
                minWidth: "",
                type: item.type
              });
            }
          } else {
            this.question_list.push({
              id: item.id,
              label: value,
              width: "",
              minWidth: 120,
              type: item.type
            });
          }
        }
      });
    },
    // 获取问卷答案值
    getValue(row, id, type) {
      if (row && row.questions && row.questions[id]) {
        if (
          row.questions[id].type != "text" &&
          row.questions[id].type != "textarea"
        ) {
          if (type) {
            return row.questions[id].type;
          } else {
            return URL_PATH + row.questions[id].text;
          }
        } else {
          return row.questions[id].text;
        }
      } else {
        return "";
      }
    },
    // 查看问卷详情
    surveyInfo(val) {
      let questions = JSON.parse(JSON.stringify(val.questions));
      let arr = [];
      for (let i in questions) {
        let info = this.question_list.find((item) => {
          if (item.id == i) {
            return item;
          }
        });
        if (info && info.label) {
          questions[i]["label"] = info.label;
        }
        arr.push(questions[i]);
      }
      this.$root.$emit("showAnswerInfo", { arr: arr, info: val });
    },
    // 分页控制
    currentChange(val) {
      this.loading = true;
      this.elementui_page_key++;
      this.currentPage = val;
      this.getAuditList();
    },
    // 审核通过拒绝删除操作后重新渲染列表
    refresh(msg) {
      this.$message({
        message: msg,
        type: "success"
      });
      this.getAuditList();
    },
    // 勾选状态
    handleSelectionChange(val) {
      this.selection = [];
      this.delSelection = [];
      // this.export_selection = [];
      if (val && val.length > 0) {
        val.forEach((item) => {
          this.delSelection.push(item.answer_id);
          this.selection.push(item.id);
          // this.export_selection.push(item.answer_id);
        });
      }
    },
    // 通过拒绝审核操作
    $pass(type) {
      if (this.selection.length > 0) {
        this.$root.$emit("showSurveyAudit", {
          arr: this.selection,
          type: type
        });
      } else {
        this.$message.error("至少选中一条数据");
      }
    },
    // 删除待审核问卷
    $del() {
      if (this.selection.length > 0) {
        this.$confirm("是否删除该问卷答案", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$api
              .delAnswer({
                token: localStorage.getItem("token"),
                survey_id: this.survey_info.survey_id,
                answer_ids: JSON.stringify(this.delSelection)
              })
              .then(({ data }) => {
                this.getAuditList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              })
              .catch(({ error }) => {});
          })
          .catch(() => {});
      } else {
        this.$message.error("至少选中一条数据");
      }
    }
    // downloadAll() {
    //   this.$nextTick(() => {
    //     this.$refs._surveyExportAnswerList.show(this.survey_info.survey_id);
    //   });
    // },
    // download() {
    //   if (this.export_selection.length == 0) {
    //     this.$message.error("至少选中一条数据");
    //     return true;
    //   } else {
    //     this.$nextTick(() => {
    //       this.$refs._surveyExportAnswerList.show(
    //         this.survey_info.survey_id,
    //         JSON.stringify(this.export_selection)
    //       );
    //     });
    //   }
    // }
  },
  created() {
    this.height = document.documentElement.clientHeight - 300;
    this.getAuditList();

    this.$root.$on("refresh_list", (msg) => {
      this.refresh(msg);
    });
  },
  beforeDestroy() {
    this.$root.$off("refresh_list");
  }
};
</script>

<style lang="less" scoped>
.top {
  position: relative;
}
.top .btn-group-custom {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  right: 32px;
}
.top .btn-group-custom .el-button--text {
  color: #595959;
}
.top .btn-group-custom .el-button--text:hover {
  color: #1890ff;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}

.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .box {
  padding: 24px 15px;
}
.box .item {
  color: #595959;
  margin-bottom: 16px;
  display: flex;
}
.box .item .text {
  flex: 1;
}
.empty {
  color: rgb(148, 148, 148);
  text-align: center;
}
.el-pagination {
  margin: 20px 0;
}
</style>
<style>
.survey-list .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgb(156, 156, 156);
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-corner {
  background: #efefef;
}

.selectTitle {
  padding-left: 10px;
  background-color: #eff9fe;
  border-radius: 3px;
  border: 1px solid #2383e0;
  height: 40px;
  line-height: 40px;
}
.selectTitleNum {
  color: #2383e0;
}
.selectTitleClear {
  color: #2383e0;
  margin-left: 20px;
  cursor: hand;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/surveyAudit.vue